"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteNotificationByActionDTOSchema = exports.MembershipReportDTOSchema = void 0;
var zod_1 = require("zod");
var Notification_1 = require("./Notification");
exports.MembershipReportDTOSchema = zod_1.z.object({
    _id: zod_1.z.coerce.string(),
    fullName: zod_1.z.string(),
    email: zod_1.z.string(),
    lastLogin: zod_1.z.coerce.date().optional(),
    MembershipType: zod_1.z.string().optional(),
    MembershipNumber: zod_1.z.coerce.string().optional(),
    RenewalDate: zod_1.z.date().optional(),
    IssueDate: zod_1.z.date().optional(),
    Status: zod_1.z.string(),
});
exports.DeleteNotificationByActionDTOSchema = zod_1.z.object({
    userId: zod_1.z.string(),
    notificationType: zod_1.z.nativeEnum(Notification_1.NOTIFICATION_TYPE),
    notificationTypeId: zod_1.z.string(),
});
//# sourceMappingURL=MembershipReportDTO.js.map